import { useEffect, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { getRemainingTime } from 'utils/helpers'
import { useAuth } from 'hooks'
import { IntlContext } from 'features/multilingual'
import { getAuthUser, tokenize } from 'features/auth/authSlice'
import { getFavoriteFiles } from 'features/favorite/favoriteSlice'
import { getLanguages } from 'features/auth/appSlice'
import { getLastSync } from 'features/sync-data/syncSlice'
import { getNotifications } from 'features/bell-notification/notificationSlice'

export const useAppInitialize = () => {
    const context = useContext(IntlContext)
    const dispatch = useDispatch()
    const { authUser, isAuthenticated, isAuthorized } = useAuth()

    useEffect(() => {
        if (isAuthenticated === null) {
            dispatch(getAuthUser())
        }
        if (isAuthenticated) {
            const expAt = window.localStorage.getItem('exp')
            const remainingTime = getRemainingTime(expAt)

            if (!isNaN(+expAt) && expAt?.length === 10 && remainingTime <= 3600) {
                dispatch(tokenize(+expAt))
            }

            dispatch(getLanguages())
            dispatch(getNotifications())
            isAuthorized && dispatch(getLastSync())
            isAuthorized && dispatch(getFavoriteFiles())
        }
    }, [dispatch, isAuthenticated])

    useEffect(() => {
        if (isAuthenticated) {
            context.setLanguage(authUser.language)
        }
    }, [authUser])

    return {
        isAuthenticated,
    }
}
